<template>
    <div class="order-search__redeem-session-btn">
        <SquareBtn size="lg"
                   color="success"
                   :disabled="unredeemedTicketsForSessionCount < 1"
                   :loading="redeeming"
                   @click="redeem">
            {{ l('ORDER_LIST.REDEEM_BTN_LABEL') }}
            <small v-if="unredeemedTicketsForSessionCount > 0">
                <i class="fa-solid fa-ticket-simple"></i> x{{ unredeemedTicketsForSessionCount }}
                <i class="fa-solid fa-user"></i> x{{ unredeemedPeopleForSessionCount }}
            </small>
        </SquareBtn>

        <span v-if="redeemedTicketsForSessionCount > 0"
              class="order-search__redeem-session-btn__already_redeemed text-warning">
            <i class="fa-solid fa-ticket-simple"></i> x{{ redeemedTicketsForSessionCount }}
            <i class="fa-solid fa-user"></i> x{{ redeemedPeopleForSessionCount }}
            <span>{{ l('ORDER_LIST.ALREADY_REDEEMED') }}</span>
        </span>
    </div>
</template>

<script>
import SquareBtn from '@/vue/components/SquareBtn';
import { container } from '@/container';
import { countRedemptionsOnLines } from '@/lib/Lines/lineCalculations';
import { findLinesForSession } from '@/lib/Lines/filterLines';

export default {
    components: { SquareBtn },

    props: {
        order: {
            type: Object,
            required: true,
        },

        sessionWithEvent: {
            type: Object,
            required: true,
        },
    },

    computed: {
        session() {
            return this.sessionWithEvent.session;
        },

        /**
         * Filters the lines in the order to only those for the desired session.
         *
         * @return {OrderLine[]}
         */
        linesForSession() {
            return findLinesForSession(
                this.order,
                this.sessionWithEvent.session.ID
            );
        },

        /**
         * Returns a total count of redeemed and unredeemed tickets and people on all lines in the order
         * that are for the desired session.
         *
         * @return {{tickets: {total: number, unredeemed: number, redeemed: number}, people: {total: number, unredeemed: number, redeemed: number}}}
         */
        redemptionCount() {
            return countRedemptionsOnLines(this.linesForSession);
        },

        unredeemedTicketsForSessionCount() {
            return this.redemptionCount.tickets.unredeemed;
        },

        unredeemedPeopleForSessionCount() {
            return this.redemptionCount.people.unredeemed;
        },

        redeemedTicketsForSessionCount() {
            return this.redemptionCount.tickets.redeemed;
        },

        redeemedPeopleForSessionCount() {
            return this.redemptionCount.people.redeemed;
        },

        redeeming() {
            for (let i = 0; i < this.linesForSession.length; i++) {
                if (this.linesForSession[i].redemptionIsInProgress()) {
                    return true;
                }
            }

            return false;
        },
    },

    methods: {
        redeem() {
            container.ticketRedeemer.redeemLines(
                this.order,
                this.linesForSession
            );
        },
    },
};
</script>

<style lang="less">
.order-search__redeem-session-btn {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    text-align: center;

    .btn {
        height: 48px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: 0;
        padding-bottom: 0;
        line-height: normal;
        font-size: 15px;

        > small {
            margin: 1px 0 1px 0; // .btn small has some margin by default so zero that.
            font-size: 12px;
            opacity: 0.8; // Makes it a little bit more subtle.
            line-height: normal;
        }
    }

    // Already redeemed text underneath the button.
    &__already_redeemed {
        margin-top: 4px;
        font-size: 13px;
    }

    // Add space around the ticket and person icons.
    .btn > small,
    &__already_redeemed {
        i:not(:first-child),
        span:not(:first-child) {
            margin-left: 2px;
        }
    }

}
</style>
